module.exports = __webpack_public_path__ + "img/software-detail.31e0cdc6.png";